import React from "react";
import { Scale, Target, Eye } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-24 bg-white text-black">
      <div className="max-w-7xl mx-auto px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-20">
          {/* Eyebrow with border lines */}
          <div className="mb-6 border-t border-b border-black py-4 inline-block">
            <span className="text-xs font-sans tracking-widest uppercase font-light">
              About Us
            </span>
          </div>

          {/* Main Heading - Serif */}
          <h2 className="text-6xl md:text-7xl font-black text-black mt-6 mb-6" style={{fontFamily: 'Georgia, serif'}}>
            Legal Lions<br />
            People Association
          </h2>

          {/* Divider Line */}
          <div className="w-32 h-1 bg-black mx-auto mt-8 mb-8"></div>

          {/* Description */}
          <p className="max-w-3xl mx-auto text-lg md:text-xl font-sans font-light text-gray-700 leading-relaxed">
            Committed to promoting legal awareness, social responsibility, public welfare, and justice for all citizens through education, guidance, and community service.
          </p>
        </div>

        {/* Cards Grid - Clean Black and White */}
        <div className="grid md:grid-cols-3 gap-12 mb-20">
          
          {/* Vision Card */}
          <div className="border-2 border-black p-8 hover:bg-black hover:text-white transition duration-300 group">
            {/* Icon Box */}
            <div className="w-16 h-16 border-2 border-black group-hover:border-white flex items-center justify-center mb-6 group-hover:bg-white group-hover:text-black transition">
              <Eye size={32} strokeWidth={1.5} />
            </div>

            {/* Heading */}
            <h3 className="text-2xl font-black mb-4" style={{fontFamily: 'Georgia, serif'}}>
              OUR VISION
            </h3>

            {/* Description */}
            <p className="font-sans font-light text-base leading-relaxed">
              To create a society where every citizen is aware of their legal rights and has equal access to justice and support.
            </p>
          </div>

          {/* Mission Card */}
          <div className="border-2 border-black p-8 hover:bg-black hover:text-white transition duration-300 group">
            {/* Icon Box */}
            <div className="w-16 h-16 border-2 border-black group-hover:border-white flex items-center justify-center mb-6 group-hover:bg-white group-hover:text-black transition">
              <Target size={32} strokeWidth={1.5} />
            </div>

            {/* Heading */}
            <h3 className="text-2xl font-black mb-4" style={{fontFamily: 'Georgia, serif'}}>
              OUR MISSION
            </h3>

            {/* Description */}
            <p className="font-sans font-light text-base leading-relaxed">
              To spread legal awareness, support community welfare activities, educate people about their rights, and encourage responsible citizenship.
            </p>
          </div>

          {/* Values Card */}
          <div className="border-2 border-black p-8 hover:bg-black hover:text-white transition duration-300 group">
            {/* Icon Box */}
            <div className="w-16 h-16 border-2 border-black group-hover:border-white flex items-center justify-center mb-6 group-hover:bg-white group-hover:text-black transition">
              <Scale size={32} strokeWidth={1.5} />
            </div>

            {/* Heading */}
            <h3 className="text-2xl font-black mb-4" style={{fontFamily: 'Georgia, serif'}}>
              OUR VALUES
            </h3>

            {/* Description */}
            <p className="font-sans font-light text-base leading-relaxed">
              Justice, Integrity, Equality, Service, Leadership, and Social Responsibility are the foundation of our organization.
            </p>
          </div>
        </div>

        {/* Bottom CTA Section - Black Background */}
        <div className="bg-black text-white p-12 md:p-16">
          {/* Heading */}
          <h3 className="text-5xl md:text-6xl font-black text-center mb-6" style={{fontFamily: 'Georgia, serif'}}>
            Empowering People Through Legal Knowledge
          </h3>

          {/* Divider */}
          <div className="w-32 h-1 bg-white mx-auto my-8"></div>

          {/* Description */}
          <p className="text-lg md:text-xl font-sans font-light text-gray-300 max-w-4xl mx-auto text-center leading-relaxed mb-8">
            We believe that awareness is the first step toward justice. Through seminars, workshops, legal guidance programs, and social initiatives, we work to strengthen communities and support individuals in understanding their rights and responsibilities.
          </p>

          {/* CTA Button */}
          <div className="flex justify-center">
            <button className="bg-white text-black px-8 py-4 font-sans font-bold text-sm hover:bg-gray-200 transition flex items-center gap-2 group">
              Learn More
              <span className="group-hover:translate-x-1 transition">→</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;